import { Component, inject, OnInit } from '@angular/core';
import { GungAnalyticsConsentService } from '../../services/gung-analytics-consent/gung-analytics-consent.service';

@Component({
  selector: 'lib-gung-cookie-consent',
  templateUrl: './gung-cookie-consent.component.html',
  styleUrls: ['./gung-cookie-consent.component.css'],
  standalone: false
})
export class GungCookieConsentComponent implements OnInit {

  private gungAnalyticsConsentService = inject(GungAnalyticsConsentService);


  ngOnInit(): void {
    if (localStorage.getItem('cookiesAccepted') === null) {
      localStorage.setItem('cookiesAccepted', 'false');
    }
  }

  showBanner = !this.cookieSelectionCompleted();

  cookieSelectionCompleted(): boolean {
    return localStorage.getItem('cookieSelectionCompleted') === 'true';
  }

  acceptCookies(): void {
    this.gungAnalyticsConsentService.setConsent(true);
    localStorage.setItem('cookieSelectionCompleted', 'true');
    this.showBanner = false;
  }

  declineCookies(): void {
    this.gungAnalyticsConsentService.setConsent(false);
    localStorage.setItem('cookieSelectionCompleted', 'true');
    this.showBanner = false;
  }
}
